import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { ReactElement, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useStoreActions, useStoreState } from '~/store/hooks';
import useRole from '~/store/user/hooks/useRole';

import Loader from '~/ui/components/common/Loader';
import { extractErrorMessage } from '~/utils/error/error';
import TeamMembers from '../../LocalAdmin/TeamMembers';
import Profile from '../../reusable/Profile';

import styles from './MyActTeam.module.scss';

const MyActTeam = (): ReactElement => {
  const { state: locationState }: { state: { selectedTab: number } } = useLocation();

  const { isLocalAdmin, team } = useRole();

  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(locationState?.selectedTab || 0);

  // a plug for TeamMembers component
  const [, setTeamMember] = useState(null);

  const { clinic: userClinic } = useStoreState(state => state.user.current);
  const actTeam = useStoreState(state => state.actTeam.current);
  const actTeamId = team?.id ? String(team?.id) : null;

  const onGetMyClinic = useStoreActions(actions => actions.clinic.onGetMyClinic);
  const { onGetClinicActTeam, resetPagination } = useStoreActions(actions => actions.actTeam);
  const showError = useStoreActions(actions => actions.snackbar.showError);

  const onMount = useCallback(async () => {
    try {
      resetPagination();
      setLoading(true);
      const payload = { clinicId: String(userClinic.id), actTeamId };

      const promises = [onGetClinicActTeam(payload)];

      if (isLocalAdmin) {
        promises.push(onGetMyClinic());
      }

      await Promise.all(promises);
      setLoading(false);
    } catch (e) {
      showError(extractErrorMessage(e));
    }
  }, [
    actTeamId,
    isLocalAdmin,
    onGetClinicActTeam,
    onGetMyClinic,
    resetPagination,
    showError,
    userClinic.id,
  ]);

  useEffect(() => {
    if (actTeamId) {
      onMount();
    }
  }, [actTeamId, onMount]);

  if (loading || !actTeam || !actTeamId) return <Loader />;

  return (
    <div>
      <div className={styles.header}>
        <h2>{actTeam.name}</h2>
      </div>
      <div className={styles.tabsWrapper}>
        <Tabs
          value={tab}
          textColor="primary"
          indicatorColor="primary"
          onChange={(_e, val) => setTab(val)}
        >
          <Tab label="TEAM PROFILE" value={0} />
          <Tab label="TEAM MEMBERS" value={1} />
        </Tabs>
      </div>
      {tab === 0 && <Profile actTeam={actTeam} />}
      {tab === 1 && (
        <TeamMembers
          noActions
          clinicId={String(userClinic.id)}
          actTeamId={actTeamId}
          setTeamMember={setTeamMember}
        />
      )}
    </div>
  );
};

export default MyActTeam;
